import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { authSimpleCanActivate } from "@delon/auth";
import { LayoutDefaultComponent } from "src/app/layout/default/default.component";
import { BillingComponent } from "./billing.component";

const routes: Routes = [
    {
		path: "",
		component: LayoutDefaultComponent,
		canActivate: [authSimpleCanActivate],
		data: {title: "billing", titleI18n: "GENERAL.BILLING"},
		children: [
			{
				path: "",
				component: BillingComponent,
				data: {title: "Billing/Wallet", titleI18n: "GENERAL.BILLING"},
			}
		],
	},
]

@NgModule({
    imports:[RouterModule.forChild(routes)],
    exports:[RouterModule]
})

export class BillingRoutingModule {}